module.exports = __webpack_public_path__ + "img/lalamove.332419d1.png";